<!--Card with title, text, and button alongside an image.
    Required (2 each):
    - Card title
    - Card text
    - Title of button
    - Link for button 
    - Color for banner in background
-->

<template>
  <main :class="`${this.block.value.color.color_choice}-color`">
    <mdb-container fluid>
      <mdb-row>
        <mdb-col>
          <mdb-container>
            <mdb-row class="pt-5 px-2" v-if="block.value.title_and_text">
              <mdb-col class="text-center">
                <h2 v-if="block.value.title_and_text.title" class="pb-2" ><strong>{{block.value.title_and_text.title}}</strong></h2>
                <p v-if="block.value.title_and_text.text" >{{block.value.title_and_text.text}}</p>
              </mdb-col>
            </mdb-row>
            <mdb-row class="pt-2 pb-5" v-for="(card, index) in block.value.card_and_card_banner.card_and_card" :key="index" :card="card">
              <mdb-col>
                <mdb-card-group deck>

                  <!--Left Card -->

                  <mdb-card class="lg=6 mb-3 z-depth-2">
                    <mdb-card-header class="text-left">{{card.left_card.title}}</mdb-card-header>
                    <mdb-card-body>
                      <mdb-card-text class="text-center">{{ card.left_card.text }}</mdb-card-text>
                    </mdb-card-body>
                    <router-link class="pb-4" :to="`/${card.left_card.link.link_page.link_page}/${card.left_card.link.link_page.slug}`">
                      <mdb-btn color="primary">{{ card.left_card.link.link_name }}</mdb-btn>
                    </router-link>
                  </mdb-card>

                  <!--Right Card-->

                  <mdb-card class="lg=6 mb-3 z-depth-2">
                    <mdb-card-header class="text-left">{{card.right_card.title}}</mdb-card-header>
                    <mdb-card-body>
                      <mdb-card-text class="text-center">{{ card.right_card.text }}</mdb-card-text>
                    </mdb-card-body>
                    <router-link class="pb-4" :to="`/${card.right_card.link.link_page.link_page}/${card.right_card.link.link_page.slug}`">
                      <mdb-btn color="primary">{{ card.right_card.link.link_name }}</mdb-btn>
                    </router-link>
                  </mdb-card>
                </mdb-card-group>
              </mdb-col>
            </mdb-row>
          </mdb-container>
        </mdb-col>
      </mdb-row>
    </mdb-container>
    <div :class="{ 'component-pattern': block.value.pattern.show_pattern}"></div>
  </main>
</template>

<script>
import {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbCardText,
    mdbBtn,
    mdbCardGroup
} from "mdbvue"
export default {
    name: "card_and_card_banner",
    props: {
        block: Object,
    },
    components: {
        mdbContainer,
        mdbRow,
        mdbCol,
        mdbCard,
        mdbCardHeader,
        mdbCardBody,
        mdbCardText,
        mdbBtn,
        mdbCardGroup
    },
}
</script>